var map = {
	"./glitch-preview": 866,
	"./glitch-preview.jpg": 866,
	"./wave-drawer": 867,
	"./wave-drawer-glitched": 868,
	"./wave-drawer-glitched.png": 868,
	"./wave-drawer.png": 867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 950;